import { __spreadArray } from "tslib";
import ModuleRegistry from 'react-module-container/dist/src/module-registry';
export var openModal = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return ModuleRegistry.invoke.apply(ModuleRegistry, __spreadArray(['businessManager.openModal'], args, false));
};
//# sourceMappingURL=open-modal.js.map